import { render, staticRenderFns } from "./HotelList.vue?vue&type=template&id=b487411e&scoped=true&"
import script from "./HotelList.vue?vue&type=script&lang=js&"
export * from "./HotelList.vue?vue&type=script&lang=js&"
import style0 from "./HotelList.vue?vue&type=style&index=0&id=b487411e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b487411e",
  null
  
)

export default component.exports